import React, { useRef, useState } from "react";
import QuestionMark from "../../assets/icons/vector.svg";
import TooltipPortal from "../../components/tooltipportal_v2/TooltipPortal";
import FallbackImg from "../FallbackImg";

const BranchDropdownOption = ({
  branch,
  shippingDetail,
  totalCBM,
  totalAmount,
  isRed,
  shippingFee,
}) => {
  const quesmarkRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const showQuesmark =
    shippingDetail &&
    (!shippingDetail.is_free_shipping || shippingDetail.is_east_malaysia);

  return (
    <div className={`branch-custom-dropdown-option_v2 ${isRed ? 'item-charged_v2' : 'item-free_v2'}`}>
      <div className="branch-item-content_v2">
        <div className="branch-column_v2">
          <div className="branch-column-label_v2">Branch</div>
          <div className="branch-column-value_v2">
            <span className={`branch-status-dot_v2 ${isRed ? 'dot-red_v2' : 'dot-green_v2'}`}></span>
            <span style={{ marginLeft: 8 }}>{branch.branch_code}</span>
          </div>
        </div>

        <div  className="branch-column_v2">
          <div className="branch-column-label_v2">Total Volume (CBM)</div>
          <div className="branch-column-value_v2">{totalCBM.toFixed(4)}</div>
        </div>

        <div  className="branch-column_v2">
          <div className="branch-column-label_v2">Delivery Charges</div>
          <div className={`branch-column-value_v2 ${isRed ? 'shipping-charged_v2' : 'shipping-free_v2'}`} style={{ position: 'relative' }}>
            {isRed ? (
              <>
                <span className="branch-custom-dropdown-RM_v2">RM</span> {shippingFee.toFixed(2)}
              </>
            ) : (
              <span className="free-text_v2">FREE</span>
            )}
            {showQuesmark && (
              <span
                ref={quesmarkRef}
                style={{ cursor: "help", display: "inline-flex", position: "absolute", right: 63, top: 0 }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <FallbackImg src={QuestionMark} alt="questionmark" width="16" height="16" />
              </span>
            )}
            {showQuesmark && (
              <TooltipPortal anchorRef={quesmarkRef} show={showTooltip}>
                {shippingDetail?.is_east_malaysia
                  ? "Orders under 0.5 CBM are charged as 0.5 CBM"
                  : !shippingDetail?.is_free_shipping
                  ? "RM 10 shipping fee for orders below RM 300"
                  : "Free Shipping"}
              </TooltipPortal>
            )}
          </div>
        </div>

        <div  className="branch-column_v2">
          <div className="branch-column-label_v2">Sub Total</div>
          <div className="branch-column-value_v2">
            <span className="branch-custom-dropdown-RM_v2">RM</span> {totalAmount.toFixed(2)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BranchDropdownOption;
